import { Box, Typography, Button } from "@mui/material";
import ConstructionIcon from "@mui/icons-material/Construction";
import { PAGE_COPY } from "@/constants/pages";

export const UnderConstruction = () => {
  const underConstructionCopy = PAGE_COPY.sections.underConstruction;

  return (
    <Box
      sx={{
        py: 12,
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        maxWidth: 600,
        mx: "auto",
        px: 2,
      }}
    >
      <ConstructionIcon
        sx={{
          fontSize: 80,
          color: "primary.main",
          mb: 2,
        }}
      />

      <Typography variant="h2" sx={{ mb: 2 }}>
        {underConstructionCopy.title}
      </Typography>

      <Typography
        variant="body1"
        sx={{
          color: "text.secondary",
          mb: 4,
          lineHeight: 1.7,
        }}
      >
        {underConstructionCopy.description.split("\n").map((line, index) => (
          <Box key={`${line}-${index}`} component="span" display="block">
            {line || "\u00A0"}
          </Box>
        ))}
      </Typography>

      <Button
        variant="contained"
        color="primary"
        href={underConstructionCopy.contactPath}
        sx={{ px: 4, py: 1.5 }}
      >
        {underConstructionCopy.contactLabel}
      </Button>
    </Box>
  );
};
